function Svg() {

    this.render = function(icon) {
        return '<svg role="img" class="icon-' + icon + '">' +
                        '<use xlink:href="' + Hideaways.svgSymbolsFile + '#icon-' + icon + '"></use>' +
                    '</svg>'
    }
}
